import UCC from "./UCC";

export default UCC;
